import { VorderCurrentGenqlSelection } from "@/gql/gen";

export const VorderCurrentFields: VorderCurrentGenqlSelection = {
    ID: true,
    ATTR: {
        __fragment: 'OrderAttrsFields',
    },
    DELIVERY_PRICE_RULES: {
        DATE: true,
        PRICE: true
    },
    BONUSES_AVAILABLE: true,
    BONUSES_PERCENT: true,
    // BASKET_RULES removed - using DISCOUNTS instead in new discount system
    DISCOUNTS: {
        __fragment: 'DiscountFields',
    },
    DELIVERIES: {
        ID: true,
        NAME: true,
        PRICE: true,
        SERVICE: {
            ID: true,
            NAME: true,
            TRANSPORT_TYPE: true
        }
    },
    TRANSPORT_TYPES: {
        CODE: true,
        NAME: true,
        DISCOUNT: true,
    },
    PAYMENT_TYPES: {
        CODE: true,
        NAME: true,
        ICON: true
    },
    ORDER: {
        PRICE: true,
    },
    COUPONS: {
        __fragment: 'CouponFields'
    },
    COUPON_CAN_ADD: true,
    BASKET: {
        ITEMS: {
            __fragment: 'BasketItemFields'
        },
        PRICE: true,
        BASE_PRICE: true,
    },
    RESPONSE_STATE: {
        messages: {
            type: true,
            message: true,
            code: true,
            data: true,
        },
    },
}
